import { GetterTree } from 'vuex';
import { State } from '@/manager/billing/store/state';
import Bill from '@/manager/billing/models/bill.model';

export interface Getters {
    getBillList: Bill[];
}

export const getters: GetterTree<State, any> = {
    getBillList: (state) => state.list,
    getBill(state: State) {
        return (id: string) => {
            return state.list.find(
                (bill: any) => bill.id === id,
            );
        };
    },
    getBillNote(state: State) {
        return (noteId: string) => {
            return state.billNoteList.find((note: any) =>  note.id === noteId);
        };
    },
    getBillNotes(state: State) {
        return (billId: string) => {
            return state.billNoteList.filter((note: any) =>  note.billId === billId);
        };
    },
    getCurrentBill: (state) => state.currentBill,
    editingCurrentBill: (state) => state.currentBill.id !== undefined,
    currentBillHasLastLineEmpty(state: State): boolean {
        const lines = (state.currentBill as any).billLine;
        const linesLength = lines.length;
        const product = lines[linesLength - 1].product;
        return product === undefined || product === null || product !== undefined && product.id === undefined;
    },
    currentBillHasLineProduct(state: State): boolean {
        const lines = (state.currentBill as any).billLine;
        const filter = lines.filter((line: any) => {
            return (line.product && line.product.id && line.productAmount > 0) || (line.product && line.productAmount > 0);
        });
        return filter.length > 0;
    },
    currentBillReceivedHasLineProduct(state: State): boolean {
        const lines = (state.currentBill as any).billLine;
        const filter = lines.filter((line: any) => {
            return line.productName && line.productAmount > 0 && line.productPrice && line.productTax;
        });
        return filter.length > 0;
    },
};
